<template>
  <div class="container cards mt-4">
    <TopNav
      :title="$t('GENERAL.LABEL.SETTINGS')"
      :showOpenMainNav="true"
      :icon="['far', 'wrench']"
    />
    <div class="row mb-4">
      <div
        class="col-lg-6 p-3"
        v-for="({ cardInfo }, cardInfoIndex) in activeSettingsGroups"
        :key="cardInfoIndex"
      >
        <router-link :to="cardInfo.to" active-class="link" class="link">
          <SettingsCard
            :smallTitle="$t(cardInfo.smallTitle)"
            :mainTitle="$t(cardInfo.mainTitle)"
            :description="$t(cardInfo.description)"
            :img="cardInfo.img"
            :buttonText="$t(cardInfo.buttonText)"
          ></SettingsCard>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import SettingsCard from '@/web/components/settings/SettingsCard';
import { getConfig } from '@/web/utils/configuration';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

export default Vue.extend({
  components: {
    SettingsCard,
    TopNav,
  },
  mixins: [TeacherPermissionsMixin],
  computed: {
    settingsGroups() {
      return [
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.ACCOUNT',
            mainTitle: 'SETTINGS.TITLE.ACCOUNT_INFORMATION',
            description: 'SETTINGS.TEXT.ACCOUNT_DESCRIPTION',
            img: '/assets/images/settings/account_info.svg',
            buttonText: 'SETTINGS.BUTTON.EDIT_INFO',
            to: '/settings/account',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.EXTRA_CUSTOMIZATION',
            mainTitle: 'SETTINGS.TITLE.CUSTOMIZE_URL',
            description: 'SETTINGS.TEXT.EDIT_URL',
            img: '/assets/images/settings/custom_domain.svg',
            buttonText: 'SETTINGS.BUTTON.SET_UP_URL',
            to: '/settings/domain',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.MAKE_IT_YOURS',
            mainTitle: 'SETTINGS.TITLE.BRANDING',
            description: 'SETTINGS.TEXT.BRANDING',
            img: '/assets/images/settings/branding.svg',
            buttonText: 'SETTINGS.BUTTON.UPDATE_BRANDING',
            to: '/settings/branding',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.EXTRA_CONNECTIONS',
            mainTitle: 'SETTINGS.TITLE.INTEGRATIONS',
            description: 'SETTINGS.TEXT.INTEGRATIONS',
            img: '/assets/images/settings/integrations.svg',
            buttonText: 'SETTINGS.BUTTON.CONFIGURE_INTEGRATIONS',
            to: '/settings/integrations',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.CONFIGURE_INSTRUCTORS',
            mainTitle: 'SETTINGS.TITLE.MANAGE_INSTRUCTORS',
            description: 'SETTINGS.TEXT.INSTRUCTORS',
            img: getConfig()['settings-instructors-img'],
            buttonText: 'SETTINGS.BUTTON.EDIT_INSTRUCTORS',
            to: '/media/instructors',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.CONFIGURE_ADMINS',
            mainTitle: 'SETTINGS.TITLE.MANAGE_ADMINS',
            description: 'SETTINGS.TEXT.ADMINS',
            img: '/assets/images/settings/admins.svg',
            buttonText: 'SETTINGS.BUTTON.EDIT_ADMINS',
            to: '/settings/admins',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.LIMIT_LIABILITY',
            mainTitle: 'SETTINGS.TITLE.CUSTOM_WAIVER',
            description: 'SETTINGS.TEXT.CUSTOM_WAIVER',
            img: '/assets/images/settings/custom_waiver.svg',
            buttonText: 'SETTINGS.BUTTON.EDIT_WAIVER',
            to: '/settings/custom-waiver',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.ADD_CUSTOM_LABELS',
            mainTitle: 'SETTINGS.TITLE.CUSTOM_LABELS',
            description: 'SETTINGS.TEXT.CUSTOM_LABELS_DESC',
            img: '/assets/images/settings/sitting_on_beanbag_coral.svg',
            buttonText: 'SETTINGS.BUTTON.EDIT_CUSTOM_LABELS',
            to: '/settings/label-editor',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.INTEGRATE',
            mainTitle: 'SETTINGS.TITLE.WEBSITE_WIDGETS',
            description: 'SETTINGS.TEXT.WIDGET_CARD_TEXT',
            img: '/assets/images/settings/widgets.svg',
            buttonText: 'SETTINGS.TEXT.EXPLORE_WIDGETS',
            to: '/settings/widgets',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.ADD_CUSTOM_CODE_TO_YOUR_STUDIO',
            mainTitle: 'SETTINGS.TITLE.CODE_EMBED',
            description: 'SETTINGS.TEXT.CUSTOM_CODE_CARD_TEXT',
            img: '/assets/images/settings/code_embed.svg',
            buttonText: 'SETTINGS.TEXT.ADD_CUSTOM_CODE',
            to: '/settings/code-embed',
          },
        },
        {
          cardInfo: {
            smallTitle: 'SETTINGS.TITLE.IMPORT_DATA_TO_YOUR_STUDIO',
            mainTitle: 'SETTINGS.TITLE.DATA_IMPORT',
            description: 'SETTINGS.TEXT.DATA_IMPORT_CARD_TEXT',
            img: '/assets/images/settings/couch.svg',
            buttonText: 'SETTINGS.TEXT.IMPORT_DATA',
            to: '/settings/data-import',
            hidden: !this.hasPermission('has_data_import'),
          },
        },
      ];
    },
    activeSettingsGroups() {
      return this.settingsGroups.filter(setting => !setting.cardInfo.hidden);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.link {
  color: $dark-gray;
  text-decoration: none;
}
</style>
